// extracted by mini-css-extract-plugin
export var contactIcon = "footer-module--contact-icon--c15d3";
export var contactItem = "footer-module--contact-item--a9a1b";
export var footer = "footer-module--footer--33bb1";
export var footerBottom = "footer-module--footer-bottom--592d3";
export var footerBottomLinks = "footer-module--footer-bottom-links--91cf9";
export var footerBrand = "footer-module--footer-brand--f85db";
export var footerInner = "footer-module--footer-inner--e12c4";
export var footerLogo = "footer-module--footer-logo--7c1ad";
export var footerSection = "footer-module--footer-section--02f75";
export var footerSocial = "footer-module--footer-social--2eb35";
export var footerSubtext = "footer-module--footer-subtext--51b2a";
export var prenotaLabel = "footer-module--prenota-label--9a889";
export var prenotaSub = "footer-module--prenota-sub--28d66";